document.addEventListener('DOMContentLoaded', function() {
	document.querySelector('select[name="options[Item]"]').addEventListener('change', function(e) {
		e.preventDefault(); 
	});
});

/*offer form*/ 
function openFormFun(){
	let overlay = document.getElementById('overlay');
	let slideForm = document.getElementById('slideForm');
	slideForm.classList.add('active');
	overlay.classList.add('active');
	document.body.style.overflow = 'hidden';
}

function closeFormFun(){
	let overlay = document.getElementById('overlay');
	let slideForm = document.getElementById('slideForm');
	slideForm.classList.remove('active');
	overlay.classList.remove('active');
	document.body.style.overflow = ''; 
}


/*tabs toggle*/
function toggleAccordion(header) {
	const contents = document.querySelectorAll('.tabs_content');
	const headers = document.querySelectorAll('.tabs_head');
	
	const content = header.nextElementSibling;
	const isActive = content.classList.contains('active');
	
	contents.forEach(item => {
		item.classList.remove('active');
	});
	
	headers.forEach(item => {
		item.classList.remove('active');
	});
	
	if (!isActive) {
		content.classList.add('active');
		header.classList.add('active');
	}
}

// tabs description mobile
if(window.screen.width < 1024){
	$("tabs-component .product-tabNav-mobile").click(function(){
		let isOpen = $(this).attr("data-open")
		let groupIndex = $(this).attr("data-group-index")
		if(isOpen == "false"){
			$(".tabs-component-content").hide()
			$(`.tabs-component-content[data-group-index="${groupIndex}"]`).fadeIn(300)
			$(this).attr("data-open",true).siblings(".product-tabNav-mobile").attr("data-open",false)
		}else{
			$(`.tabs-component-content[data-group-index="${groupIndex}"]`).hide()
			$(this).attr("data-open",false)
		}
	})
}

/* Product FAQ: convert H4 + following content into accordion items */
function initCsProductFaq() {
	document.querySelectorAll('[data-cs-faq-source]').forEach(function (source) {
		if (source.getAttribute('data-converted') === 'true') return;

		var headings = Array.prototype.slice.call(source.querySelectorAll('h4'));
		if (!headings.length) {
			source.setAttribute('data-converted', 'true');
			return;
		}

		var accordion = document.createElement('div');
		accordion.className = 'cs-product-faq__accordion';

		headings.forEach(function (heading) {
			var details = document.createElement('details');
			details.className = 'cs-faq-item';

			var summary = document.createElement('summary');
			summary.className = 'cs-faq-item__question';

			var questionText = document.createElement('span');
			questionText.className = 'cs-faq-item__question-text';
			questionText.textContent = heading.textContent.trim();

			var icon = document.createElement('span');
			icon.className = 'cs-faq-item__icon';
			icon.setAttribute('aria-hidden', 'true');

			summary.appendChild(questionText);
			summary.appendChild(icon);

			var answer = document.createElement('div');
			answer.className = 'cs-faq-item__answer rte';

			var node = heading.nextSibling;
			while (node && !(node.nodeType === 1 && node.tagName === 'H4')) {
				var next = node.nextSibling;
				answer.appendChild(node);
				node = next;
			}

			details.appendChild(summary);
			details.appendChild(answer);
			accordion.appendChild(details);
		});

		source.innerHTML = '';
		source.appendChild(accordion);
		source.setAttribute('data-converted', 'true');
	});

	initCsProductFaqDefaultOpen();
}

function initCsProductFaqDefaultOpen() {
	var isDesktop = window.matchMedia('(min-width: 750px)').matches;

	document.querySelectorAll('.cs-product-faq').forEach(function (faq) {
		var items = faq.querySelectorAll('.cs-faq-item');
		items.forEach(function (item, index) {
			if (isDesktop && index === 0) {
				item.setAttribute('open', '');
			} else if (!isDesktop) {
				item.removeAttribute('open');
			}
		});
	});
}

document.addEventListener('DOMContentLoaded', initCsProductFaq);
window.addEventListener('resize', initCsProductFaqDefaultOpen);